import { takeLatest, put, call, all } from 'redux-saga/effects';
import { getAccountsCount } from '@api/partner-ad-accounts';
import {
  fetchPartnerAdAccountsCounts,
  fetchPartnerAdAccountsCountsSucceed,
} from '@redux/ducks/partnerAdAccounts/partnerAdAccounts';

// Workers

export function* fetchAccountsCountsTask() {
  try {
    const accountCounts = yield call(getAccountsCount);

    yield put(fetchPartnerAdAccountsCountsSucceed(accountCounts));
  } catch (error) {
    // eslint-disable-next-line no-console
    console.log(error);
  }
}

// Watchers

export function* watchFetchAccountsCounts() {
  yield takeLatest(fetchPartnerAdAccountsCounts, fetchAccountsCountsTask);
}

// Saga

export default function* partnerAdAccountsSaga() {
  yield all([watchFetchAccountsCounts()]);
}
